// 種別ごとに取得できない図面のチェックを不可にする。
// ルールは既存 /acquiremultiplebooks の checkDisable 表と同一

const LAND_DISABLED_FIELDS = new Set(["buildingDrawings"]);
const BUILDING_DISABLED_FIELDS = new Set([
  "electricDrawings",
  "tisekiDrawings",
  "tiekiDrawings",
]);

// 照合APIの realEstateType は種別マスタの名称をそのまま返すため、キーは日本語名で持つ
const DISABLED_FIELDS_BY_TYPE: Record<string, Set<string>> = {
  土地: LAND_DISABLED_FIELDS,
  建物: BUILDING_DISABLED_FIELDS,
  区分建物: BUILDING_DISABLED_FIELDS,
};

export const isCheckboxDisabled = (
  field: string,
  realEstateType: string
): boolean => DISABLED_FIELDS_BY_TYPE[realEstateType]?.has(field) ?? false;
